module.exports = __webpack_public_path__ + "img/villa-and-house.ce8a805.jpg";